module.exports = __webpack_public_path__ + "./images/red_thumb.e095c7.jpg";